import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyPages.css';

const ReturnsPage = () => {
    return (
        <div className='policy-page'>
            <div className='policy-hero'>
                <div className='container'>
                    <h1>Return &amp; Refund Policy (Rahber Corporation, Since 1980)</h1>
                    <p>
                        How returns, refunds, and cancellations work for your
                        purchases.
                    </p>
                </div>
            </div>

            <div className='container policy-body'>
                <article className='policy-prose'>
                    <p className='lead'>
                        We want our customers to be fully satisfied with their
                        purchases.
                    </p>

                    <h2>1. Return eligibility</h2>
                    <ul>
                        <li>Returns are accepted within 7 days of delivery.</li>
                        <li>
                            Product must be:
                            <ul>
                                <li>Unused</li>
                                <li>In original condition</li>
                                <li>With original packaging</li>
                            </ul>
                        </li>
                    </ul>

                    <h2>2. Non-returnable items</h2>
                    <ul>
                        <li>
                            Used or damaged items (not caused during delivery).
                        </li>
                        <li>Items without original packaging.</li>
                    </ul>

                    <h2>3. Damaged / wrong product</h2>
                    <p>If you receive a damaged or incorrect item:</p>
                    <ul>
                        <li>Report within 24 hours.</li>
                        <li>Share photo or video proof.</li>
                    </ul>
                    <p>We will arrange a replacement or refund.</p>

                    <h2>4. Refund process</h2>
                    <ul>
                        <li>Refunds are processed after inspection.</li>
                        <li>
                            Approved refunds will be issued within 5 to 7 working
                            days.
                        </li>
                    </ul>

                    <h2>5. Shipping costs</h2>
                    <ul>
                        <li>
                            If the return is due to our mistake, we cover
                            shipping.
                        </li>
                        <li>
                            If the customer changes their mind, the customer
                            pays return shipping.
                        </li>
                    </ul>

                    <h2>6. Cancellation policy</h2>
                    <ul>
                        <li>Orders can be cancelled before shipment.</li>
                        <li>Once shipped, cancellation is not possible.</li>
                    </ul>

                    <div className='policy-note'>
                        <strong>Please note:</strong> During busy hours,
                        cancellation requests may take some time to process.
                    </div>

                    <p>
                        Warranty and service questions? See{' '}
                        <Link to='/warranty'>Warranty</Link>. For help with a
                        return, <Link to='/contact'>Contact</Link> us.
                    </p>

                    <p className='policy-meta'>Last updated: April 2026</p>
                </article>
            </div>
        </div>
    );
};

export default ReturnsPage;
